import React, { useEffect, useState } from 'react'
import styles from './SpecialOffers.module.scss'
import CategoryProduct from '../CategoryProduct'
import { fetchModalData } from 'src/store/slices/manageModalSlice'
import { useAppDispatch } from 'src/store/store'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { fetchMobileModalData } from 'src/store/slices/mobileModalSlice'
import { fetchProductByCategory } from 'src/store/slices/fetchAllProduct'
import { useRouter } from 'next/router'
export default function SpecialOffers({ backgroundColor }) {
  const dispatch = useAppDispatch()
  const router = useRouter()
  const getAllState = useSelector((state: any) => state?.manageModalData?.data)
  const fetchMobileModal = useSelector((state: any) => state?.manageMobileModal?.data)
  const [specialOffersData, setSpecialOffersData] = useState([])

  useEffect(() => {
    fetchProduct()
  }, [])

  const fetchProduct = () => {
    dispatch(
      fetchProductByCategory({
        category: 'fashion-and-accessories',
        subCategory: router?.asPath?.includes('women') ? "women-accessories" : "men-accessories",
        childSubCategory: router?.asPath?.includes('women') ? 'scarves' : 'hats',
        isShopifyProduct: false,
        page: 1,
        limit: 12,
      }),
    ).then((response) => {
      setSpecialOffersData(response?.payload?.getAllProducts?.data)
    })
  }  

  return (
    <div className={styles.specialOffersSetion}>
      <div className={styles.specialOffersHeader}>
        <h4>Special Offers</h4>
{/* 
        <div
          className={classNames(styles.seeMoreButton, styles.webView)}
          onClick={() => {
            dispatch(
              fetchModalData({
                ...getAllState,
                allModalData: [
                  ...getAllState?.allModalData,
                  { modal: 'categorySpecialOffers', isOpen: true, id: { width: 70 }, modalFor: 'bigModal' },
                ],
                lastModalData: getAllState?.lastModalData,
              }),
            )
          }}
        >
          <a>See more</a>
        </div>

        <div
          className={classNames(styles.seeMoreButton, styles.mobileView)}
          onClick={() =>
            dispatch(
              fetchMobileModalData({
                allModalData: [
                  ...(fetchMobileModal?.allModalData ? fetchMobileModal?.allModalData : []),
                  { modal: 'mobileSpeacialOffer', isOpen: true, id: 0, transform: 60 },
                ],
                lastModalData: fetchMobileModal?.lastModalData,
              }),
            )
          }
        >
          <a>See more</a>
        </div> */}
      </div>

      <div className={styles.specialOffersBodyAlignment} style={{ backgroundColor: backgroundColor }}>
        <div className={styles.specialOffersGrid}>
          {specialOffersData?.map((item, index) => {
            return (
              <div className={styles.specialOffersGridItem} key={`c${index}`}>
                <CategoryProduct index={index} item={item} />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
